module.exports = __webpack_public_path__ + "static/media/youtube.67f4eaee.svg";